import { useEffect } from 'react';
import {Link} from 'react-router-dom';
import {Row, Col, Button, Space} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';


import './styles/Home.css';
import thaiBoats from '../images/thai-boats-1.jpg';
import smugCoins from '../images/smug-gold-coin-arabs.jpg';
import baroquePortrait from '../images/baroque-woman-bitcoin-portrait.jpg';
import walletOfFuture from '../images/wallet-of-future.jpg';
import podcastersImage from '../images/podcasters.jpeg';
import theFutureIsBright from '../images/the-future-is-bright.jpeg';
import helpingAtComputer from '../images/helping-at-computer.jpg';
import watchInternals from '../images/watch-internals.jpg';

import { IS_ADMIN } from '../const/const';

const storage = localStorage;

const Home = () => {

    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if(auth.loginDetails) {
            const isAdmin = storage.getItem(IS_ADMIN);

            navigate(isAdmin && auth.userRole === 'admin' ? '/admin/dashboard' : '/transactions');
        }
      }, []);

    return (
        <div>
            <Helmet>
                <link rel="canonical" href={`https://punkypay.com${location.pathname}`} />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <Row justify="center">
                <Col>
                    
                    {/* Intro */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text">Cheap and Fast International Payments</h2>
                            <p className="auth-title-text">
                                Punkypay makes cross-border payments dramatically cheaper and faster than traditional methods.
                            </p>
                            <p className="auth-title-text">
                                <ul>
                                    <li><b>~1% in fees</b> compared to ~4% for international wire transfer and ~7% for international credit card transactions</li>
                                </ul>
                                <ul>
                                    <li><b>Transfers settle in ~3 minutes</b> compared to 2-30 days with traditional methods</li>
                                </ul>
                            </p>
                            <p className="auth-title-text">
                                If you want to see how much Punkypay will save you, <Link class="light-blue" to="/cost-breakdown">click here </Link>
                            </p> 

                            {/* <h2 className="auth-title-text"> International Payments. Way cheaper. Way Faster. </h2>          
                            <p className="auth-title-text">
                                International transactions on Punkypay settle for about 0.1%. 
                                This is way cheaper than international wire transfers which settle for about 4%, and international credit card transactions which settle for about 7%.  
                            </p>
                            <p className="auth-title-text">
                                All transactions on Punkypay settle in about 3 minutes. 
                                International wire transfers settle in about 2 business days and international credit card transactions settle in about 5 business days. 
                            </p>*/}
                        </div>
                        <div className="image-container">
                            <img src={thaiBoats} alt="thaiBoats"/>
                        </div>
                    </div> 


                    {/* built for reliability */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text">Built for Reliability</h2>
                                    
                            <p className="auth-title-text">
                                Traditional payment methods were built for another era. 
                                They are slow and leave you helpless when issues arise. 
                            </p>
                            <p className ="auth-title-text">
                                Punkypay puts you back in control. 
                                Your funds dont pass through unknown middlemen, giving you full transparency from start to finish.
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={watchInternals} alt="watchInternals"/>
                        </div>
                    </div> {/* end container */}


                    {/* useful not theoretical */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> How it Works </h2>
                                    
                            <p className="auth-title-text">
                                With Punkypay, you use the US Dollar in cryptocurrency format. 
                                This combines the speed and cost savings of cryptocurrencies with the strength of the US Dollar. 
                            </p>

                            <p className ="auth-title-text">
                                Punkypay is like a credit card network, but rather than networking together banks, Punkypay networks together crypto exchanges. 
                            </p>

                            <p className ="auth-title-text">
                                The result is a simple payment method with lightning speed and low cost.
                            </p>
                            {/* <p className="auth-title-text">
                                By using the US Dollar in crypto format, you can get your money to your destination 99% faster than any other 
                                payment method for about 95% less. 
                            </p>
                            <p className="auth-title-text">
                                Each transaction settles in about 3 minutes and costs 1% of the total amount sent. 
                                Once your money reaches its destination, the recipient can easily convert their US Dollars into local currency.
                            </p> */}
                            {/* <p className="auth-title-text">
                                <i> As our introductory offer, we aren't charging these fees. Contact <a class="light-blue" href="mailto:sales@punkypay.com">sales@punkypay.com</a> for more information. </i>
                            </p> */}
                        </div>
                        <div className="image-container">
                            <img src={smugCoins} alt="smugCoins"/>
                        </div>
                    </div> {/* end container */}


                    {/* intutiive intercace  */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text">Easy to Use</h2>
                            {/* Intuitive Interface  */}
                            {/* <p className="auth-title-text">
                                Cryptocurrencies have been plagued by poor user interface since their inception. 
                            </p> */}
                            <p className="auth-title-text">
                                Punkypay makes paying with crypto easy. 
                                Instead of sending money to someone’s hexidecimal crypto address, you simply send money to their email.  
                            </p>
                            <p className="auth-title-text">
                                In addition, Punkypay keeps detailed notes about your transactions which far exceed the quality of those provided by your bank or credit card.
                                {/* ADD SOEMTHING */}
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={helpingAtComputer} alt="helping-at-computer"/>
                        </div>
                    </div> {/* end container */}

                    {/* upgrade your wallet  */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Upgrade your wallet. Upgrade your life. </h2>
                                    
                            <p className="auth-title-text">
                                There are <em>so many</em> use cases for Punkypay. You can use it to pay offshore workers, import goods, live abroad, and much more.
                            </p>
                            <p className="auth-title-text">
                                How will Punkypay <Link class="light-blue" to="/use-cases">help you</Link>?
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={walletOfFuture} alt="walletOfFuture"/>
                        </div>
                    </div> {/* end container */}
                    {/* 
                        Upgrade your business. 
                        There are so many use cases for Punkypay that we can't mention every one of them.
                        How will Punkypay help your business?
                        MAYBE THROW IN A LINK TO SALES@PUNKYPAY.COM, AFTER I START SELLING THIS
                    */}

                    {/* Our Referral Program */}
                    <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Refer friends, make money. </h2>
                            <p className="auth-title-text"> 
                                Turn your network into earnings with Punkypay. 
                                When you refer a friend, you’ll earn <b>50% of the platform fees</b> Punkypay collects from them for the first <b>five years</b> after they sign up. 
                            </p>

                            <p className="auth-title-text">
                                Start sharing, start earning, and let your network <Link class="light-blue" to="/refer-friends-make-money">work for you</Link>.
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={theFutureIsBright} alt="the-future-is-bright"/>
                        </div>
                    </div>

                    {/* The future is bright */}
                    {/* <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> The Future is Bright </h2>
                            <p className="auth-title-text"> 
                                Punkypay is awesome right now, but it's getting better. 
                            </p>

                            <p className="auth-title-text">
                                Check out our <Link class="light-blue" to="/roadmap">roadmap into the future</Link>. 
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={theFutureIsBright} alt="the-future-is-bright"/>
                        </div>
                    </div>  */}


                    {/* Podcast */}
                    {/* <div className="container">
                        <div className="text-container">
                            <h2 className="auth-title-text"> Introducing the Punkypay Podcast </h2>
                            <p className="auth-title-text"> 
                                Punkypay's long-form podcast interviews explorers, entrepeneurs, and engineers building our future. 
                                Unlike other podcasts, we have first-hand experience building products and bringing them to market - so we can truly empathise with our fellow adventurers.
                            </p>

                            <p className="auth-title-text">
                            Find <Link class="light-blue" to="/podcast">more info</Link> about our podcast here. 
                            </p>
                        </div>
                        <div className="image-container">
                            <img src={podcastersImage} alt="podcasters-image"/>
                        </div>
                    </div>  */}
                </Col>
            </Row>
        </div>
        
    )
}

export default Home;


